module.exports = __webpack_public_path__ + "img/download.b8b0d4bc.svg";